import type { SVGProps } from 'react'
const SvgSyChatAltAdd = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="M4 12c0-2.8 0-4.2.545-5.27A5 5 0 0 1 6.73 4.545C7.8 4 9.2 4 12 4s4.2 0 5.27.545a5 5 0 0 1 2.185 2.185C20 7.8 20 9.2 20 12v6c0 .943 0 1.414-.293 1.707S18.943 20 18 20h-6c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C4 16.2 4 14.8 4 12"
		/>
		<path d="M12 8.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5" />
		<path d="M9 11.5a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
	</svg>
)
export default SvgSyChatAltAdd
